export default {
  "common.mode.auto": "Eigenverbrauch",
  "common.mode.economy": "Wirtschaftsmodus",
  "common.mode.exigency": "Notfallmodus",

  "common.grid": "Stromnetz",
  "common.evChargers": "Ladestationen",
  "common.evCharger": "Ladestation",
  "common.pv": "Photovoltaik",
  "common.inverter": "Wechselrichter",
  "common.pcs": "Wechselrichter+Batterie",
  "common.terminal": "Endgerät",
  "common.airc": "Klimaanlage",
  "common.engine": "Generator",
  "common.battery": "Batterie",
  "common.metter": "Stromzähler",
  "common.other": "Andere",
  "common.power": "Leistung",
  "common.powerTotal": "Gesamtleistung",
  "common.voltage": "Spannung",
  "common.electricity": "Strommenge",
  "common.current": "Stromstärke",
  "common.homeUsage": "Hausgesamlast",
  "common.battery.power": "Batterieleistung",

  "common.noDataAvailable": "Keine Daten verfügbar~",
  "common.tips": "Hinweis",
  "common.reset": "Zurücksetzen",
  "common.currencyUnit": "€",
  "common.submiting": "Wird übermittelt, bitte warten...",
  "common.close": "Schließen",
  "common.from": "Von",
  "common.useIn": "Verwendet für",
  "common.energyPercent": "Energieflussanteil",
  "common.dataFlow": "Datenfluss",
  "common.getDataIng": "Daten werden abgerufen, bitte warten...",
  "common.pageLoading": "Seiteninhalt wird geladen, bitte warten...",
  "common.reseting": "Seiteninhalt wird zurückgesetzt, bitte warten...",
  "common.save": "Speichern",
  "common.onlyNumberTips": "Nur Zahlen eingeben",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Fehler",
  "common.charge": "Laden",
  "common.discharge": "Entladen",
  "common.buy": "Bezug",
  "common.sell": "Einspeisung",
  "common.loadingInfo": "Wird geladen, bitte warten...",

  "common.moreFeatures": "Weitere Funktionen",
  "common.confirm": "Bestätigen",
  "common.saveing": "Wird gespeichert, bitte warten...",
  "common.searchPlacholder": "Suchbegriff eingeben",
  "common.iSee": "Verstanden",
  "common.pageErrorTips1": "Hoppla, Seitenfehler~",
  "common.pageErrorTips2": "Bitte versuchen Sie zu aktualisieren oder kontaktieren Sie den Support~",
  "common.refresh": "Aktualisieren",
  "common.backToHome": "Zurück zur Startseite",
  "common.checkTips": "Wird geprüft, bitte warten...",
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.optional": "Optional",
  "common.required": "Erforderlich",
  "common.status": "Status",
  "common.statusNoDelete": "Nicht gelöscht",
  "common.statusDelete": "Gelöscht",
  "common.submit": "Absenden",
  "common.disable": "Deaktivieren",
  "common.enable": "Aktivieren",
  "common.year": "Jahr",
  "common.month": "Monat",
  "common.day": "Tag",
  "common.version": "Version:",
  "common.backHome": " Zur Startseite",
  "common.backHomeSorry": " Entschuldigung, die Seite hat sich verirrt",
  "common.requestTips1": "Daten werden verarbeitet, bitte nicht wiederholen",
  "common.requestTips2": "Systemhinweis",
  "common.requestTips3": "Anmeldestatus abgelaufen, bitte erneut anmelden",
  "common.requestTips4": "Erneut anmelden",
  "common.requestTips5": "Ungültige Sitzung oder Sitzung abgelaufen, bitte erneut anmelden.",
  "common.requestTips6": "Serverfehler, bitte versuchen Sie es später erneut.",
  "common.requestTips7": "System-Schnittstellenanfragezeitüberschreitung",
  "common.requestTips8": "System-Schnittstelle",
  "common.requestTips9": "Fehler",
  "common.iknow": "Verstanden",
  "common.logoutSuccess": "Abmeldung erfolgreich",

  "common.knowMore.title": "Weitere Informationen, kontaktieren Sie BN Energy",
  "common.knowMore.email": "E-Mail-Kontakt",
  "common.knowMore.phone": "Telefonkontakt",
  "common.knowMore.wechat": "WeChat-Kontakt",
  "common.knowMore.website": "Offizielle Website",
  "common.knowMore.address": "Kontaktadresse",
  "common.knowMore.addressDetail": "Raum 1205, 1301, Gebäude 5, Nr. 8 Qinghe Road, Huangjingkeng, Huangjiang Town, Dongguan City, Guangdong Province",

  "common.localConnection": "Lokale Verbindung",
  "common.operateInApp": "Bitte in der App operieren!",

  "common.enbleStaus": "Aktivierungsstatus",
  "common.battery.status": "Weder Laden noch Entladen",

  "account.forgetThePassword": "Passwort vergessen",
  "account.logInDirectly": "Direkt zur Anmeldung",
  "account.tips1": "Seite wird umgeleitet, bitte warten...",
  "account.tips2": "Bitte lesen und akzeptieren Sie die Nutzungsbedingungen!",
  "account.autoLogin": "Automatische Anmeldung",
  "account.userLogin": "Benutzeranmeldung",
  "account.registerTips": "Noch keinen Account? Hier zur Registrierung",
  "account.userEmail": "Benutzername/E-Mail",
  "account.userEmailTips": "Bitte Benutzername/E-Mail eingeben",
  "account.password": "Passwort",
  "account.passwordTips": "Bitte Passwort eingeben",
  "account.submit": "Absenden",
  "account.submitTips": "Wird übermittelt, bitte warten...",
  "account.otherLoginTips": "Oder andere Anmeldemethoden wählen",
  "account.userRegistration": "Benutzerregistrierung",
  "account.userName": "Benutzername",
  "account.userNameTips": "Bitte Benutzername eingeben",
  "account.emailTips1": "Bitte E-Mail-Adresse eingeben",
  "account.emailTips2": "E-Mail-Adressformat falsch",
  "account.phone": "Telefonnummer",
  "account.phoneTips1": "Bitte Telefonnummer eingeben",
  "account.phoneTips2": "Telefonnummer falsch",
  "account.phoneTips3": "Bitte Telefonnummer eingeben",
  "account.passwordTips1": "Bitte 6-30-stelliges Passwort eingeben",
  "account.passwordTips2": "Passwortformat falsch, Passwort muss aus Buchstaben, Zahlen, Unterstrich, Bindestrich, Punkt frei kombiniert sein, Länge 6-12 Stellen",
  "account.passwordTips3": "Passwörter stimmen nicht überein, bitte überprüfen und erneut eingeben!",
  "account.passwordTips4": "Bitte Passwort eingeben, Passwort muss aus Buchstaben, Zahlen, Unterstrich, Bindestrich, Punkt frei kombiniert sein",
  "account.passwordTips5": "Passwort bestätigen",
  "account.passwordTips6": "Bitte Bestätigungspasswort eingeben",
  "account.passwordTips7": "Passwörter stimmen nicht überein, bitte überprüfen und erneut eingeben!",
  "account.passwordTips8": "Bitte Bestätigungspasswort eingeben",
  "account.passwordTips9": "Glückwunsch, Registrierung erfolgreich!",
  "account.passwordTips10": "Ihr Benutzername ist:",
  "account.emailIs": "E-Mail ist:",
  "account.goToLoginPage": "s später automatische Weiterleitung zur Anmeldeseite",
  "account.goLogin": "Zur Anmeldung",
  "account.goRegister": "Registrieren",
  "account.loginSuccess": "Anmeldung erfolgreich",
  "account.email": "E-Mail",
  "account.sologn": "Maßgeschneiderte Energielösungen für Sie",
  "account.pleaseAgree": "Ich habe gelesen und akzeptiere",
  "userAgreement.privacyPolicy": "Datenschutzrichtlinie",

  "account.code": "Verifizierungscode",
  "account.codeTips": "Bitte Verifizierungscode eingeben",
  "account.codeTips2": "Verifizierungscode falsch",

    "account.inviteCodeTips": "Bitte Einladungscode eingeben",
    "account.inviteCodeHint": "Bitte kontaktieren Sie den Installateur oder das Betriebspersonal, um den Einladungscode zu erhalten",
  "account.modifyPasswordByAccount": "Passwortänderung per Account",
  "account.modifyPasswordByEmail": "Passwortänderung per E-Mail",
  "account.getPasswordByAccount": "Passwortwiederherstellung per Account",
  "account.getPasswordByEmail": "Passwortwiederherstellung per E-Mail",

  "account.sendEmailTips": "Verifizierungscode an E-Mail gesendet, bitte Postfach prüfen",
  "account.name": "Accountname",
  "account.newPassword": "Neues Passwort",
  "account.confirmNewPassword": "Neues Passwort bestätigen",
  "account.nameTips": "Bitte Accountname eingeben",
  "account.passwordModifySuccess": "Passwortänderung erfolgreich",
  "account.emailCode": "E-Mail-Verifizierungscode",
  "account.emailCodeTips": "Bitte E-Mail-Verifizierungscode eingeben",
  "account.emailCodeTips2": "E-Mail-Verifizierungscode falsch",
  "account.emailModifySuccess": "Passwortänderung erfolgreich",
  "account.passworTips1": "Ihr Passwort wurde erfolgreich zurückgesetzt!",
  "account.passwordTips11": "Bitte Bestätigungspasswort eingeben",
  "account.passwordTips12": "Bitte neues Passwort eingeben",
  "account.nickname": "Benutzername",
  "account.modifyNickname": "Benutzernamen ändern",
  "account.modifyNicknameSuccess": "Benutzername erfolgreich geändert!",
  "account.nicknameTips": "Bitte Benutzernamen eingeben",
  "account.nicknameError": "Benutzernamenänderung fehlgeschlagen!",

  "account.login": "Anmelden",
  "account.quickRegister": "Schnellregistrierung",
  "account.sendCode": "Code erhalten",
  "account.sendTips": "s erneut sendbar",
  "account.sendEmailIng": "E-Mail wird gesendet, bitte warten...",
  "account.emailNotEmpty": "E-Mail-Adresse darf nicht leer sein",
  "account.registerAccount": "Account registrieren",
  "account.registerWelcome": "Willkommen bei SusprSafe",
  "account.usernameLimit": "Benutzername muss mit Buchstabe beginnen, darf nur Buchstaben, Zahlen, Unterstrich enthalten, Länge 5-15 Zeichen",

  "copyright.desc2": "Website-Filing-Information: YueICP-2021169764",

  "editUserInfo.editUserInformation": "Benutzerinformationen bearbeiten",
  "editUserInfo.modifyUsername": "Benutzernamen ändern",
  "editUserInfo.changePictures": "Profilbild ändern",
  "editUserInfo.savePicturesSuccess": "Profilbild erfolgreich gespeichert",
  "editUserInfo.saveError": "Speichern fehlgeschlagen",
  "editUserInfo.pictureLimit": "Bild muss kleiner 2MB sein",
  "editUserInfo.uploadPicture": "Profilbild hochladen",
  "editUserInfo.picturePreview": "Vorschau",

  "editUserInfo.bindPhoneNumber": "Telefonnummer binden",
  "editUserInfo.bindEmail": "E-Mail binden",
  "editUserInfo.changePassword": "Passwort ändern",

  "editUserInfo.notificationSettings": "Benachrichtigungseinstellungen",
  "editUserInfo.editAccount": "Benutzerkontoinformationen bearbeiten",
  "editUserInfo.waitBingting": "Wird gebunden, bitte warten...",
  "editUserInfo.collapse": "Einklappen",
  "editUserInfo.modifyBinding": "Bindung ändern",

  "editUserInfo.emailAddress": "E-Mail-Adresse",
  "editUserInfo.tips1": "E-Mail-Bindung erfolgreich",
  "editUserInfo.tips2": "Speichern fehlgeschlagen",
  "editUserInfo.tips3": "E-Mail-Verifizierungscode wird gesendet, bitte warten...",
  "editUserInfo.tips4": "Verifizierungscode an E-Mail xxxx gesendet, bitte prüfen",
  "editUserInfo.tips5": "Code erhalten fehlgeschlagen!",
  "editUserInfo.tips6": "Telefonnummer bereits gebunden",
  "editUserInfo.tips7": "E-Mail bereits gebunden",
  "editUserInfo.emailTips1": "Bitte E-Mail-Adresse eingeben",
  "editUserInfo.emailTips2": "E-Mail-Adressformat falsch",
  "editUserInfo.emailTips3": "xxxxs erneut sendbar",
  "editUserInfo.emailTips4": "Code erhalten",
  "editUserInfo.emailTips5": "E-Mail-Verifizierungscode darf nicht leer sein",
  "editUserInfo.emailTips6": "E-Mail-Verifizierungscode falsch",
  "editUserInfo.emailCode": "E-Mail-Verifizierungscode",
  "editUserInfo.save": "Speichern",

  "editUserInfo.phoneTips1": "Telefonnummer-Bindung erfolgreich",
  "editUserInfo.phoneTips2": "SMS-Verifizierungscode wird gesendet, bitte warten...",
  "editUserInfo.phoneTips3": "SMS-Verifizierungscode an Telefon xxxx gesendet, bitte prüfen",
  "editUserInfo.phoneTips4": "SMS-Code erhalten fehlgeschlagen!",
  "editUserInfo.phoneTips5": "Bitte Telefonnummer eingeben",
  "editUserInfo.phoneTips6": "Telefonnummernformat falsch",
  "editUserInfo.phoneTips7": "SMS-Code erhalten",
  "editUserInfo.phoneTips8": "SMS-Verifizierungscode",
  "editUserInfo.phoneTips9": "Telefon-Verifizierungscode darf nicht leer sein",
  "editUserInfo.phoneTips10": "Telefon-Verifizierungscode falsch",
  "editUserInfo.phone": "Telefonnummer",

  "editUserInfo.noticeTips1": "Benachrichtigungskonfiguration abrufen fehlgeschlagen!",
  "editUserInfo.noticeTips2": "Benachrichtigungseinstellungen erfolgreich gespeichert!",
  "editUserInfo.noticeTips3": "Niedriger Batteriestand-Benachrichtigung",
  "editUserInfo.noticeTips4": "Ladestation Ladevorgang abgeschlossen-Benachrichtigung",
  "editUserInfo.errorNotification": "Fehlerbenachrichtigung",
  "editUserInfo.updateNotification": "Update-Benachrichtigung",
  "editUserInfo.monthlyStatisticsNotification": "Monatliche Statistik-Benachrichtigung",
  "editUserInfo.notificationMethod": "Empfangsweg",

  "editUserInfo.userNameTips1": "Benutzername erfolgreich gespeichert",
  "editUserInfo.userNameTips2": "Benutzername speichern fehlgeschlagen",
  "editUserInfo.userNameTips3": "Bitte Benutzernamen eingeben",
  "editUserInfo.userNameTips4": "Benutzernamenformat falsch, muss aus Zahlen, Unterstrich, Buchstaben bestehen",
  "editUserInfo.userNameTips5": "Bitte Benutzernamen eingeben",
  "editUserInfo.userNameTips6": "Wird gespeichert, bitte warten...",
  "editUserInfo.userName": "Benutzername",

  "editUserInfo.avatorTips": "Klicken um Profilbild zu ändern",
  "editUserInfo.verifyCodeTips1": "Bitte erhaltenen Verifizierungscode eingeben:",
  "editUserInfo.verifyCodeTips2": "Zu Ihrer Kontosicherheit, klicken Sie bitte auf die Schaltfläche unten um Verifizierungscode an ursprüngliche Telefonnummer zu senden:",
  "editUserInfo.verifyCodeTips3": "Code erhalten",
  "editUserInfo.verifyCodeTips4": "Ursprüngliche Telefonverifizierung erfolgreich, bitte neue zu bindende Telefonnummer eingeben",
  "editUserInfo.verifyCodeTips5": "Zu Ihrer Kontosicherheit, klicken Sie bitte auf die Schaltfläche unten um Verifizierungscode an ursprüngliche E-Mail zu senden:",
  "editUserInfo.verifyCodeTips6": "Ursprüngliche E-Mail-Verifizierung erfolgreich, bitte neue E-Mail eingeben",
  "editUserInfo.verifyCodeTips7": "Altes Passwort",
  "editUserInfo.verifyCodeTips8": "Bitte binden Sie zuerst eine E-Mail!",
  "editUserInfo.verifyCodeTips9": "Verifizierungscode an E-Mail gesendet, bitte Postfach prüfen",
  "editUserInfo.verifyCodeTips10": ", automatische Weiterleitung zur Anmeldeseite",

  "hems.notice.title": "Benachrichtigungstitel",
  "hems.notice.content": "Benachrichtigungsinhalt",
  "hems.notice.operate": "Aktion",
  "hems.notice.noRead": "Ungelesen",
  "hems.notice.read": "Gelesen",
  "hems.notice.warning": "Warnung",
  "hems.notice.error": "Fehler",
  "hems.notice.success": "Statistikabrechnung",
  "hems.notice.sys": "Systeminformation",
  "hems.notice.operateSuccess": "Aktion erfolgreich",
  "hems.notice.operateTips": "Bitte zu bearbeitende Elemente auswählen",

  "hems.home.selfuseRate": "Eigenverbrauchsrate",
  "hems.home.percent": "Prozentsatz",
  "hems.home.todayData": "Heutige Daten",
  "hems.home.todayPowerGeneration": "Heutige Stromerzeugung",
  "hems.home.salesIncome": "Stromeinspeiseeinnahmen",
  "hems.home.saved": "Für Sie gespart",
  "hems.home.reduce": "CO2-Fußabdruck reduzieren",
  "hems.home.tips1": "Keine Daten, Sie haben xxxx noch nicht gebunden",
  "hems.home.criticalLoad": "Kritische Last",
  "hems.home.keyVoltage": "Kritische Spannung",
  "hems.home.householdLoad": "Haushaltslast",
  "hems.home.householdVoltage": "Haushaltsspannung",
  "hems.home.generalLoad": "Allgemeine Last",
  "hems.home.generalVoltage": "Allgemeine Spannung",
  "hems.home.batteryHealth": "Batteriegesundheit",
  "hems.home.averageTemp": "Durchschnittstemperatur",
  "hems.home.gridLoad": "Netzlast",
  "hems.home.toggeleDataSource": "Angezeigte Daten umgestellt auf:",
  "hems.home.toggleTips": "Sind Sie sicher, dass Sie wechseln möchten?",
  "hems.home.modeSending": "Modusbefehl wird gesendet, bitte warten...",
  "hems.home.modeSuccess": "Moduswechselbefehl erfolgreich gesendet!",
  "hems.home.isOnline": "Online-Status",
  "hems.home.useStatus": "Nutzungsstatus",
  "hems.home.workModeText": "Aktueller Arbeitsmodus:",
  "hems.home.toggleDataSourceText": "Angezeigte Daten umgestellt auf:",
  "hems.ev.charge.status": "Ladestatus",
  "hems.ev.charge.time": "Ladedauer",
  "hems.ev.charge.count": "Echtzeit-Lademenge",
  "hems.ev.charge.status.empty": "Frei",
  "hems.ev.charge.status.ing": "Lädt",
  "hems.ev.charge.status.null": "Angeschlossen, nicht ladend",
  "hems.ev.charge.status.error": "Fehler",
  "hems.hour": "Stunde",
  "hems.minue": "Minute",
  "hems.ev.chagre.number": "Ladestationsnummer",

  "hems.userGuide.selfUse": "Eigenverbrauch",
  "hems.userGuide.selfUseTips": "Prioritäre Nutzung von Solarstrom, bei Bedarf Netzbezug",
  "hems.userGuide.economyMode": "Wirtschaftsmodus",
  "hems.userGuide.economyModeTips": "Optimierte Stromnutzung basierend auf Strompreisen",
  "hems.userGuide.emergencyMode": "Notfallmodus",
  "hems.userGuide.emergencyModeTips": "Prioritäre Versorgung kritischer Lasten",

  "hems.history.energyStatistics": "Energiestatistik",
  "hems.history.revenueStatistics": "Ertragsstatistik",
  "hems.history.greenStatistics": "CO2-Reduktion",
  "hems.history.revenueTitle": "Gesamteinspeiseeinnahmen",
  "hems.history.savingsTitle": "Gesamtersparnis",
  "hems.history.carbonTitle": "Gesamte CO2-Reduktion",
  "hems.history.day": "Tag",
  "hems.history.month": "Monat",
  "hems.history.year": "Jahr",
  "hems.history.beforeDay": "Vorheriger Tag",
  "hems.history.afterDay": "Nächster Tag",
  "hems.history.beforeMonth": "Vorheriger Monat",
  "hems.history.afterMonth": "Nächster Monat",
  "hems.history.beforeYear": "Vorheriges Jahr",
  "hems.history.afterYear": "Nächstes Jahr",
  "hems.history.totalUse": "Gesamtverbrauch",
  "hems.history.fullScreen": "Vollbild",
  "hems.history.timeSelect": "Datumsauswahl",
  "sync.tips1": "Daten-Sync-Befehl erfolgreich gesendet!",
  "sync.tips2": "Daten-Sync läuft, kann wegen Datenmenge etwas Zeit benötigen, bitte in 30 Minuten erneut prüfen~",
  "sync.tips3": "Gerätedaten-Sync kann verzögert sein, bei Datenanomalien bitte klicken:",
  "sync.tips4": "Daten synchronisieren",

  "charge.info": "Ladestationsinformation",
  "news.loading": "Lädt...",
  "news.noMore": "Keine weiteren",
  "hems.pv.power": "Solarstromversorgung",

  "ueh.sellPower": "Eingespeiste Strommenge",

  "menu.home": "Startseite",
  "menu.history": "Verlaufsdaten",
  "menu.device": "Geräte",
  "menu.settings": "Einstellungen",
  "menu.messageCenter": "Nachrichtenzentrum",
  "menu.help": "Hilfe & Support",
  "menu.mine": "Mein Bereich",

  "mine.userSetting": "Benutzereinstellungen",
  "mine.terminalSetting": "Gerätebasiseinstellungen",
  "mine.uploadCloud": "Daten-Cloud-Backup",
  "mine.changeVersion": "Update prüfen",
  "mine.language": "Sprache wechseln",
  "mine.about": "Über",
  "mine.feedback": "Feedback",
  "mine.logout": "Abmelden",
  "mine.logoutAccount": "Account löschen",

  "mine.logoutAccountTips": "Account mit Namen [] löschen",
  "mine.logoutAccountTips1": "Gebundenen Account [] löschen",
  "mine.logoutAccountCare": "Hinweise zur Account-Löschung:",
  "mine.logoutAccountCare1": "1. Account befindet sich in sicherem Zustand",
  "mine.logoutAccountCare1-1": "Account ist aktuell normal nutzbar, kein Diebstahl-, Regelverstoß-, Deaktivierungsrisiko.",
  "mine.logoutAccountCare2": "2. Account-Berechtigungen/Bindungen aufgehoben",
  "mine.logoutAccountCare2-1": "Account-Berechtigungen bei Drittanbietern wurden aufgehoben.",
  "mine.logoutAccountCare3": "3. Gelöschter Account nicht wiederherstellbar, alle Daten werden gelöscht",
  "mine.logoutAccountCare3-1": "Nach Löschung sind gebundene Telefonnummern, E-Mails und zugehörige Daten unwiederbringlich gelöscht.",
  "mine.confirmLogout": "Löschung bestätigen",
  "mine.logoutSuccess": "Account erfolgreich gelöscht!",

  "mine.feedbackIssues": "Problem melden",
  "mine.feedQuantity": "Menge",
  "mine.feedAmount": "Max. 9 Bilder, max. 1MB/Bild",

  "mine.notice.fail": "Benachrichtigungskonfiguration abrufen fehlgeschlagen!",
  "mine.notice.saveSuccess": "Benachrichtigungseinstellungen erfolgreich gespeichert!",
  "mine.notice.saveFail": "Speichern fehlgeschlagen!",
  "mine.notice.title": "Benachrichtigungseinstellungen",
  "mine.notice.batteryLow": "Niedriger Batteriestand",
  "mine.notice.chargingFinish": "Ladevorgang abgeschlossen",
  "mine.notice.error": "Fehlerbenachrichtigung",
  "mine.notice.update": "Update-Benachrichtigung",
  "mine.notice.monthly": "Monatliche Statistik",
  "mine.notice.receiveType": "Empfangsweg",

  "mine.language.welcome": "Willkommen bei SusprSafe",
  "mine.language.desc1": "Bitte Sprache entsprechend Ihrer Region einstellen",
  "mine.language.desc2": "Kann jederzeit in den App-Einstellungen geändert werden",

  "mine.userInfo.avatar": "Profilbild",
  "mine.userInfo.nickname": "Benutzername",
  "mine.userInfo.password": "Passwort",
  "mine.userInfo.changePassword": "Passwort ändern",
  "mine.userInfo.setPassword": "Passwort setzen",
  "mine.userInfo.phoneNumber": "Telefonnummer",
  "mine.userInfo.bindPhone": "Telefonnummer binden",
  "mine.userInfo.bindEmail": "E-Mail binden",
  "mine.loginExpired": "Anmeldung abgelaufen, bitte erneut anmelden",
  "mine.userInfo.title": "Benutzerinformationen",
  "mine.userInfo.bind": "Binden",
  "mine.userInfo.modify": "Ändern",
  "mine.userInfo.modifyNickname": "Benutzernamen ändern",
  "mine.userInfo.userNickname": "Benutzername",
  "mine.userInfo.selectPic": "Bild zum Hochladen auswählen",
  "mine.userInfo.saveSuccess": "Erfolgreich gespeichert",
  "mine.userInfo.uploadFail": "Hochladen fehlgeschlagen",
  "mine.userInfo.avatarSaveSuccess": "Profilbild erfolgreich gespeichert",
  "mine.userInfo.nameTips1": "Benutzername darf nicht leer sein",
  "mine.userInfo.nameTips2": "Bitte Benutzernamen eingeben",

  "common.pleaseSelect": "Bitte auswählen",
  "question.commonQuestions": "Häufige Fragen",
  "account.toggleLanguage": "Sprache wechseln",
  "account.localConnection": "Lokale Verbindung",
  "account.selectLanguage": "Bitte Sprache wählen",
  "account.sendEmailToast": "Verifizierungscode an E-Mail xxx gesendet, bitte Postfach prüfen",
  "account.emailError": "E-Mail-Format falsch",
  "account.sendEmailFail": "Senden fehlgeschlagen, bitte erneut versuchen",

  "common.submitting": "Wird übermittelt, bitte warten...",

  "device.page.noData": "Keine Daten verfügbar, diese Seite ist nur in der App verfügbar",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrade läuft...",
  "bmsFirmware.uploadingFile": "Firmware-Datei wird hochgeladen...",
  "bmsFirmware.upgradingProgress": "Firmware wird aktualisiert... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade erfolgreich",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS-Firmware-Upgrade abgeschlossen!",
  "bmsFirmware.upgradeFailed": "Upgrade fehlgeschlagen",
  "bmsFirmware.upgradeFailedFormError": "Bitte überprüfen Sie, ob das Formular korrekt ausgefüllt ist",
  "bmsFirmware.upgradeFailedNetworkError": "Netzwerkfehler, bitte erneut versuchen",
  "bmsFirmware.invalidFileType": "Bitte wählen Sie eine gültige Firmware-Datei (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Bitte wählen Sie zuerst eine Firmware-Datei",
  "bmsFirmware.statusUpgrading": "Upgrade läuft",
  "bmsFirmware.statusCompleted": "Upgrade abgeschlossen",
  "bmsFirmware.statusFailed": "Upgrade fehlgeschlagen",
  "bmsFirmware.deviceUpgrading": "Firmware-Paket wird aktualisiert, Upgrade dauert 30 ~ 50 Minuten, während dieser Zeit können keine Echtzeit-Gerätedaten angezeigt werden, bitte warten...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade-Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade-Fortschritt",
  "bmsFirmware.currentPackageLabel": "Aktuelle übertragene Datenpaket-Nummer",
  "bmsFirmware.totalPackagesLabel": "Gesamtanzahl der Datenpakete",
  "bmsFirmware.upgradeFailedCheckDevice": "Bitte überprüfen Sie den Gerätestatus und versuchen Sie das Upgrade erneut",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Einstellung erfolgreich",
  "settingResult.defaultSubTitle": "Parameter-Einstellungen gespeichert",
  "settingResult.confirmButton": "OK"
}